import { jsx } from "react/jsx-runtime";
import { Image, ImageLoadingBehaviorOptions, ImageResizeOptions } from "@wix/wix-ui-tpa/cssVars";
import { ImageAlignment, ImageFit } from "../../types/image.js";
import { st, classes } from "./image-component-wut.st.css";
const getResize = (imageResize) => {
  switch (imageResize) {
    case "contain":
      return ImageResizeOptions.contain;
    case "cover":
      return ImageResizeOptions.cover;
  }
  return void 0;
};
function ImageComponentWUT(props) {
  const {
    imageResize = ImageFit.COVER,
    imageAlignment = ImageAlignment.CENTER
  } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: st(classes.imageContainer, {
        imageAlignment,
        imageResize
      }),
      style: {
        aspectRatio: props.aspectRatio ? String(props.aspectRatio) : void 0
      },
      children: props.image ? /* @__PURE__ */ jsx(
        Image,
        {
          alt: props.alt,
          resize: getResize(imageResize),
          src: props.image.id,
          loadingBehavior: ImageLoadingBehaviorOptions.spinner
        },
        props.image.id
      ) : null
    }
  );
}
export {
  ImageComponentWUT
};
//# sourceMappingURL=image-component-wut.js.map
